module.exports = __webpack_public_path__ + "img/RLP.2fef22d6.jpg";